
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";
import { SeccionState, setSeccion, setSecciones } from "../seccion/seccionSlice";

import { SeccionEjercicioState, endLoadingSeccionEjercicio, setSeccionEjercicios } from "./seccionEjercicioSlice";
import { secciones } from '../../../pages/cursosss/secciones';

export const obtenerSeccionEjerciciosModulo = (mid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`ejercicio/obtener/${mid}`);
            const body = await resp.json();

            if (body.ok) {
                const { ejercicios } = body;
                dispatch(setSeccionEjercicios(ejercicios))
                dispatch(endLoadingSeccionEjercicio());
                return
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarSeccionEjercicioUsuario = (eid: String, estado: Boolean) => {

    return async (dispatch: any, getState: any) => {

        const { ejercicios } = getState().ejercicio;

        const seccionesActualizada = ejercicios.map((item: any) => (
            item.eid === eid ?
                {
                    ...item,
                    estado: estado
                } : item
        ));

        dispatch(setSeccionEjercicios(seccionesActualizada))

    }
}


// ADMINISTRADOR
export const crearSeccionEjercicio = (ejercicio: object) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-ejercicio/crear`, ejercicio, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { seccionEjercicioCreado } = body;

                const { sid } = seccionEjercicioCreado;

                const seccionesActualizada = secciones.map((item: SeccionState) =>
                    item.sid === sid ? { ...item, ejercicios: item?.ejercicios ? [...item?.ejercicios, seccionEjercicioCreado] : [seccionEjercicioCreado] } : item
                );

                const seccionActualizada = seccionesActualizada.find((item: SeccionState) => item.sid === sid);

                dispatch(setSecciones(seccionesActualizada));
                dispatch(setSeccion(seccionActualizada));
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarSeccionEjercicio = (ejercicio: SeccionEjercicioState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { sid, eid } = ejercicio;

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-ejercicio/eliminar/${eid}`, { id: eid }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {

                const seccionesActualizada = secciones.map((item: SeccionState) =>
                    item.sid === sid ? {
                        cid: item.cid,
                        mid: item.mid,
                        bid: item.bid,
                        sid: item.sid,
                        seccion: item.seccion,
                        nombre: item.nombre,
                        diapositivas: item.diapositivas,
                        ejercicios: item?.ejercicios ? item?.ejercicios.filter((item: SeccionEjercicioState) => item.eid !== eid) : []
                    } : item
                );
                dispatch(setSecciones(seccionesActualizada))
                return
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarSeccionEjercicio = (ejercicio: SeccionEjercicioState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { sid, eid } = ejercicio;

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-ejercicio/actualizar/${eid}`, ejercicio, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const seccionesActualizada = secciones.map((item: SeccionState) =>
                    item.sid === sid ? {
                        cid: item.cid,
                        mid: item.mid,
                        bid: item.bid,
                        sid: item.sid,
                        seccion: item.seccion,
                        nombre: item.nombre,
                        diapositivas: item.diapositivas,
                        ejercicios: item?.ejercicios ? item?.ejercicios.map((item: SeccionEjercicioState) =>
                            item.eid === eid ? ejercicio : item
                        ) : []
                    } : item
                );
                dispatch(setSecciones(seccionesActualizada))
                return
            }

        } catch (error) {
            console.log(error)
        }
    }
}